import { useDispatch, useSelector } from "react-redux";
import { useFormatting } from "../translations/useFormatting";
import { Config } from "./Config";
import { RdxType } from "./Types";
import { useFetch } from "../hooks/data/useFetcher";
import { PackageName } from "../..";
import { CHANGE_UI_SERVER_BUILD_EPOCH, CHANGE_UI_SERVER_BUILD_EPOCH_LASTCHECK } from "./redux/uIReducer";


export const useAppData = () => {

    const d = useDispatch();
    const f = useFetch();

    const fn = useFormatting().numberDefault;
    const serverBuildEpoch = useSelector((state: RdxType) => state.ui.serverBuildEpoch);
    const serverBuildEpochLastCheck = useSelector((state: RdxType) => state.ui.serverBuildEpochLastCheck);
    // CHANGE_UI_SERVER_BUILD_EPOCH_LASTCHECK

    const loadBuildEpoch = async () => {
        const { apps }: { apps: { appName: string, buildEpoch: number }[] } = await f.get("/api/appversion")
        const serverEpoch = apps?.find((m) => m.appName === PackageName)?.buildEpoch ?? 0;
        d({ type: CHANGE_UI_SERVER_BUILD_EPOCH, payload: serverEpoch });


        var _now = new Date().valueOf();
        d({ type: CHANGE_UI_SERVER_BUILD_EPOCH_LASTCHECK, payload: _now });

        if (Config.buildEpoch > 0 && serverEpoch > 0 && serverEpoch < Config.buildEpoch) {
            // my build is more than server
            const p = { app: PackageName, buildEpoch: Config.buildEpoch };
            await f.patch("/api/appversion", p);
            d({ type: CHANGE_UI_SERVER_BUILD_EPOCH, payload: Config.buildEpoch });
        }

        if (Config.buildEpoch > 0 && serverEpoch > 0 && (serverEpoch > Config.buildEpoch)) {
            // my build is lower than server
        }
    }


    return {
        loadBuildEpoch: loadBuildEpoch,
        serverBuildEpoch: serverBuildEpoch,
        serverBuildEpochLastCheck: serverBuildEpochLastCheck,
        newVersionAvailable: Config.buildEpoch > 0 && serverBuildEpoch > Config.buildEpoch,

        helloEmail: Config.appData_HelloEmail,
        supportEmail: Config.appData_SupportEmail,
        addressFirstLine: Config.appData_AddressFirstLine,
        addressSecondLine: Config.appData_AddressSecondLine,
        facebookLink: Config.appData_FacebookLink,
        instagramLink: Config.appData_InstagramLink,
        appStoreLink: Config.appData_AppStoreLink,
        playStoreLink: Config.appData_PlayStoreLink,

        numberOfPlantsCount: fn(Config.appData_NumberOfPlantsCount),
        getAppLoginLink: (token: string) => {
            return Config.appData_LoginLinkNoToken + token;
        }
    }
}